(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bandido-gift-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bandido-gift-selector')) {
    customElements.define('bandido-gift-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.config = JSON.parse(this.querySelector('[data-gift-config]').textContent);
        this.inputs = [...this.querySelectorAll('input[type="checkbox"]')];
        this.button = this.querySelector('[data-gift-add]');
        this.status = this.querySelector('[data-gift-status]');
        this.count = this.querySelector('[data-gift-selection]');
        this.running = false;
        this.checkedState = null;
        this.inputs.forEach((input) => input.addEventListener('change', () => this.update()));
        this.button.addEventListener('click', () => this.add());
        this.stateListener = (event) => {
          this.checkedState = event.detail;
          if (!this.running && this.config.enabled) {
            if (event.detail.gifts.length || event.detail.unknown) this.status.textContent = this.config.already;
            else if (event.detail.paid < 15000) {
              const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: 'EUR' }).format((15000 - event.detail.paid) / 100);
              this.status.textContent = this.config.remaining.replace('[amount]', amount);
            } else this.status.textContent = this.config.eligible;
          }
          this.update();
        };
        this.refresh = () => {
          if (!this.config.enabled || !window.BandidoGiftGuard) return;
          window.BandidoGiftGuard.fresh().catch(() => {
            this.checkedState = null;
            this.status.textContent = this.config.error;
            this.update();
          });
        };
        document.addEventListener('bandido:gift-state', this.stateListener);
        document.addEventListener('bandido:gift-ready', this.refresh);
        this.refresh();
        this.update();
      }
      disconnectedCallback() {
        document.removeEventListener('bandido:gift-state', this.stateListener);
        document.removeEventListener('bandido:gift-ready', this.refresh);
        this.initialized = false;
      }
      update() {
        const count = this.inputs.filter((input) => input.checked).length;
        this.inputs.forEach((input) => { input.disabled = !this.config.enabled || this.running || (count === 5 && !input.checked); });
        this.count.textContent = this.config.selected.replace('[count]', count);
        const eligible = this.checkedState && this.checkedState.paid >= 15000 && !this.checkedState.gifts.length && !this.checkedState.unknown;
        this.button.disabled = !this.config.enabled || !window.BandidoGiftGuard || this.running || count !== 5 || !eligible;
      }
      async add() {
        if (this.running || !this.config.enabled) return;
        const selected = this.inputs.filter((input) => input.checked);
        const omitted = this.inputs.findIndex((input) => !input.checked);
        const bundle = this.config.bundles[omitted];
        const guard = window.BandidoGiftGuard;
        if (selected.length !== 5 || !guard || !bundle?.variant || !bundle.available) {
          this.status.textContent = this.config.unavailable;
          return;
        }
        this.running = true;
        this.status.textContent = this.config.loading;
        this.update();
        try {
          await guard.add(Number(bundle.variant), selected.map((input) => Number(input.dataset.product)));
          location.assign(this.config.cartUrl);
        } catch (error) {
          this.status.textContent = error.message || this.config.error;
          this.status.focus();
        } finally {
          this.running = false;
          this.update();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
